module.exports = __webpack_public_path__ + "static/media/fruits_45.590415de.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_45.csv
// module id = 712
// module chunks = 0